import { render, staticRenderFns } from "./EndorsementsEditor.vue?vue&type=template&id=b1bc594c"
import script from "./EndorsementsEditor.vue?vue&type=script&lang=ts"
export * from "./EndorsementsEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports